import { mapFields } from 'vuex-map-fields'

export default {
	watch: {
		createError (value) {
			const errors = Object.keys(value)
			errors.forEach(error => {
				this.throwWarning(value[error][0])
			})
		}
	},

    computed: {
        ...mapFields('router', {
            formData: 'createForm',
            activeTab: 'activeTab',
			deletedIds: 'deletedIds',
			createError: 'createError',
			buttonLoading: 'buttonLoading'
		}),
    },

    // beforeRouteLeave (to, from ,next) {
	// 	this.$store.commit('router/clearCreateData')
    //     next()
    // },

    methods: {
        async form () {
            const {
                name,
                macAddress,
                ipAddress,
                client,
				bands,
				id
            } = this.formData

			const form = new FormData()
			form.append('name', name)
			form.append('mac_address', macAddress)
            form.append('ip', ipAddress)

			if (id) {
				form.append('id', id)
			}

			if (this.deletedIds.length) {
				form.append('remove_band', this.deletedIds.join())
			}
			

			if (client && client.id) {
				form.append('client_id', client.id)
			}

            if (bands.length) {
				bands.forEach((item, index) => {
					if (item.macAddress !== '' && item.name !== '') {
						if (item.id) form.append(`band[${index}][id]`, item.id)
						form.append(`band[${index}][band_name]`, item.name)
						form.append(`band[${index}][mac_address]`, item.macAddress)
					}
				})
			}

            return form
		},

        async submit () {
            if (await this.validate()) {
				const form = await this.form()
				const payload = {
					form,
					store: this.$store
				}
				this.$store.dispatch('router/manageRouter', payload)
				return
            }
        },

        async validate () {
            const {
                name,
                macAddress,
                ipAddress,
                bands
            } = this.formData

            const invalidMacAddress = (value) => {
                const macAddressRegEx = /^[a-fA-F0-9]{2}(:[a-fA-F0-9]{2}){5}$/
                return !macAddressRegEx.test(value)
            }

            const invalidIPAddress = (value) => {
                const ipAddressRegEx = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}/
                return !ipAddressRegEx.test(value)
            }

            if (name.trim() === '' ||
                macAddress.trim() === '') {

                this.throwWarning('Please fill up the fields.')
                return false
            }

            if (invalidMacAddress(macAddress)) {
                this.throwWarning('Invalid MAC Address Format.')
                return false
            }

            if (invalidIPAddress(ipAddress)) {
                this.throwWarning('Invalid IP Address Format.')
                return false
            }
			
			if (bands.length &&
				(bands[0].name.trim() !== '' ||
				bands[0].macAddress.trim() !== '')
			) {
				for (const [index, band] of bands.entries()) {
					if ((band.name.trim() !== '' &&
						band.macAddress.trim() === '') || 
						(band.name.trim() === '' &&
						band.macAddress.trim() !== '')) {
						this.throwWarning('Band Name and Mac Address is required.')
						return false
					}
	
					if (invalidMacAddress(band.macAddress)) {
						this.throwWarning('Invalid MAC Address Format.')
						return false
					}

					const hasDuplicate = bands.some((_band, _index) => {
						return _band.macAddress === band.macAddress &&
								_index !== index
					})

					if (hasDuplicate) {
						this.throwWarning('MAC Address already exists.')
						return false
					}
				}
			}

            return true
        },

        throwWarning (message) {
            this.$store.commit('modal/toggleNotification', {
                notificationName: 'notification-banner',
                notificationType: 'warning',
                notificationDesc: message
            })
		}
    }
}

